import {
  _sharedActionsPlayer,
  _sharedActionsConstantsPlayer,
} from "@/shared/store/player/actions";

export const playerActionConstants = _sharedActionsConstantsPlayer;

export const playerActions = _sharedActionsPlayer;
